import Constants from './constants';
import { DocumentCapture } from './documentCapture';
import MockableDocumentCapture from './mockableDocumentCapture';
import NullDocumentCapture from './NullDocumentCapture';
import OnfidoDocumentCapture from './onfidoDocumentCapture';

const isMock = (process.env.REACT_APP_STAGE || 'unknown') === 'mock';
const isE2e =
  (process.env.REACT_APP_STAGE || 'unknown') === 'e2e' || (process.env.REACT_APP_STAGE || 'unknown') === 'preprod_e2e';

let documentCaptureInstance: DocumentCapture = new OnfidoDocumentCapture();

if (isMock) {
  documentCaptureInstance = new NullDocumentCapture();
}

if (isE2e) {
  documentCaptureInstance = new MockableDocumentCapture();
}

const documentCapture = documentCaptureInstance;
export default documentCapture;
export { Constants };
